const useLocation = (): Location => {
  if (typeof window === 'undefined') {
    return {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      port: '',
      protocol: '',
      search: '',
      assign: (_url) => {},
      reload: () => {},
      replace: (_url) => {},
    } as Location;
  }
  
  return window.location;
};

export default useLocation;
